export default (value) => value.toString().toUpperCase();
